import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <main className="pt-24 pb-16 min-h-screen bg-[#F8F6F2]" data-testid="terms-page">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 lg:p-12 shadow-sm border border-gray-100">
            <h1 
              className="text-3xl sm:text-4xl font-bold text-[#0B1C2D] mb-4"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Terms & Conditions
            </h1>
            <div className="w-20 h-1 bg-[#C6A34A] mb-8" />

            <div className="prose prose-gray max-w-none text-[#4A5568]">
              <p className="text-sm text-[#718096] mb-6">
                Last Updated: January 2026
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Acceptance of Terms
              </h2>
              <p className="mb-4 leading-relaxed">
                By accessing and using the website jurisbihar.com ("Website") operated by Chambers of 
                Adv. Ajeet Narayan Sinha, you agree to be bound by these Terms and Conditions. If you 
                do not agree with any part of these terms, please do not use our Website.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Use of Website
              </h2>
              <p className="mb-4 leading-relaxed">
                This Website is provided for informational purposes only. You agree to use the Website 
                only for lawful purposes and in a way that does not infringe upon the rights of others 
                or restrict their use and enjoyment of the Website. Prohibited conduct includes:
              </p>
              <ul className="list-disc pl-6 space-y-2 mb-6">
                <li>Posting or transmitting unlawful, defamatory, or offensive material.</li>
                <li>Attempting to gain unauthorized access to any part of the Website.</li>
                <li>Using the Website to send unsolicited communications.</li>
                <li>Interfering with the proper working of the Website.</li>
              </ul>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Intellectual Property
              </h2>
              <p className="mb-4 leading-relaxed">
                All content on this Website, including but not limited to text, graphics, logos, and 
                images, is the property of Chambers of Adv. Ajeet Narayan Sinha and is protected by 
                applicable intellectual property laws. You may not reproduce, distribute, modify, or 
                create derivative works from any content without our express written permission.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                No Legal Advice
              </h2>
              <p className="mb-4 leading-relaxed">
                The information provided on this Website is for general informational purposes only and 
                does not constitute legal advice. No attorney-client relationship is formed by your use 
                of this Website or by submitting an inquiry through our contact form. For specific legal 
                advice regarding your situation, please consult with a qualified legal professional.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Accuracy of Information
              </h2>
              <p className="mb-4 leading-relaxed">
                While we strive to provide accurate and up-to-date information, we make no warranties 
                or representations about the accuracy, reliability, or completeness of the content on 
                this Website. Laws and regulations may change, and information may become outdated. 
                Users should verify information independently.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Limitation of Liability
              </h2>
              <p className="mb-4 leading-relaxed">
                To the fullest extent permitted by law, Chambers of Adv. Ajeet Narayan Sinha shall not 
                be liable for any direct, indirect, incidental, consequential, or punitive damages 
                arising out of your access to, use of, or inability to use this Website, or any errors 
                or omissions in the content.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Third-Party Links
              </h2>
              <p className="mb-4 leading-relaxed">
                This Website may contain links to third-party websites for your convenience. We do not 
                endorse, control, or assume responsibility for the content, privacy policies, or practices 
                of any third-party websites. Accessing third-party links is at your own risk.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Indemnification
              </h2>
              <p className="mb-4 leading-relaxed">
                You agree to indemnify and hold harmless Chambers of Adv. Ajeet Narayan Sinha and its 
                associates from any claims, damages, losses, or expenses arising from your violation 
                of these Terms and Conditions or your use of this Website.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Modifications
              </h2>
              <p className="mb-4 leading-relaxed">
                We reserve the right to modify these Terms and Conditions at any time without prior 
                notice. Your continued use of the Website after any modifications indicates your 
                acceptance of the updated terms. We encourage you to review these terms periodically.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Governing Law & Jurisdiction
              </h2>
              <p className="mb-4 leading-relaxed">
                These Terms and Conditions shall be governed by and construed in accordance with the 
                laws of India. Any disputes arising from these terms or your use of this Website shall 
                be subject to the exclusive jurisdiction of the courts in Patna, Bihar.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Severability
              </h2>
              <p className="mb-4 leading-relaxed">
                If any provision of these Terms and Conditions is found to be invalid or unenforceable, 
                the remaining provisions shall continue in full force and effect.
              </p>

              <h2 className="text-xl font-semibold text-[#0B1C2D] mt-8 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Contact Information
              </h2>
              <p className="mb-4 leading-relaxed">
                For any questions regarding these Terms and Conditions, please contact us at:<br />
                Email: ajeet.sinha@jurisbihar.com<br />
                Phone: +91 9431078694<br />
                Address: 306, Devendra Residency, Kankarbagh Main Road, Patna, Bihar - 800026
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
